import { render, staticRenderFns } from "./LicenseReportForm.vue?vue&type=template&id=9afcb5e4&scoped=true&"
import script from "./LicenseReportForm.vue?vue&type=script&lang=js&"
export * from "./LicenseReportForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9afcb5e4",
  null
  
)

export default component.exports